/**
 * 現場情報
 */
export class SiteInfo {
  /** 工事番号 */
  koujiBangou: string;
  /** 現場名称 */
  name: string;
  /** 画像切り抜きサイズ */
  cropImageWidth: number;
  /** 画像切り抜きサイズ */
  cropImageHeight: number;
  /** 細分化 行サイズ */
  lineNum: number;
  /** 細分化 列サイズ */
  columnNum: number;
  /** 観察項目名 */
  observationNames: string[];
  /** 観察項目_説明 */
  observationDescriptions: string[];
  /** 総合評価用の重み情報 */
  obsrecWeights: Array<{
    obsrecKey: string;
    obsrecName: string;
    weight: number;
  }>;
  /** 評価値算出時に段階ルールを適応する観察項目名 */
  targetStepRuleObservationNames: string[];
  /** 評価値算出時に段階ルールを適応する観察項目（アルファベッド） */
  targetStepRuleObservations: string[];

  /** 評価値算出時に最頻値ルールを適応する観察項目名 */
  targetModeRuleObservationNames: string[];
  /** 評価値算出時に最頻値ルールを適応する観察項目（アルファベッド） */
  targetModeRuleObservations: string[];

  /** 評価値算出時に平均<スコア重複排除前提>ルールを適応する観察項目名 */
  targetMeanDeduplicationRuleObservationNames: string[];
  /** 評価値算出時に平均<スコア重複排除前提>ルールを適応する観察項目（アルファベッド） */
  targetMeanDeduplicationRuleObservations: string[];

  /** 評価値算出時に平均<一般>ルールを適応する観察項目名 */
  targetMeanGeneralRuleObservationNames: string[];
  /** 評価値算出時に平均<一般>ルールを適応する観察項目（アルファベッド） */
  targetMeanGeneralRuleObservations: string[];

  /** 小計に含める観察項目（アルファベッド） */
  isIncludeInSubtotalObservations: string[];
  /** 合計に含める観察項目（アルファベッド） */
  isIncludeInTotalObservations: string[];

  /** 切羽評価点換算表データ */
  excavationFaceScoreConversionTableData: Array<{
    observation: string;
    rock_group: string;
    eval_grade_0: number;
    eval_grade_1: number;
    eval_grade_2: number;
    eval_grade_3: number;
    eval_grade_4: number;
    eval_grade_5: number;
    eval_grade_6: number;
  }>;

  /** 観察項目マッピング（アルファベッドキーと名称） */
  observationMap: { [key: string]: string };

  /** 評価値算出時に段階ルールを適応する場合の「天端」の最悪値のしきい値 */
  topBadsideSize: number;
  /** 評価値算出時に段階ルールを適応する場合の「左肩」の最悪値のしきい値 */
  leftBadsideSize: number;
  /** 評価値算出時に段階ルールを適応する場合の「右肩」の最悪値のしきい値 */
  rightBadsideSize: number;
}



// WEBPACK FOOTER //
// ./src/models/SiteInfo.ts